import {
  LuMail,
  LuClipboardCheck,
  LuCalendarClock,
  LuWrench,
  LuInfo,
  LuMegaphone,
} from "react-icons/lu";
import { MdOutlineCancel } from "react-icons/md";
import { RiFileWarningFill } from "react-icons/ri";
import { useParams } from "@tanstack/react-router";
import {
  MessageType,
  useDashboardMessages,
} from "./hooks/useDashboardMessages";
const iconMap: Record<MessageType, React.ReactNode> = {
  certification: <LuClipboardCheck size={16} color="#003a5d" />,
  warning: <LuCalendarClock size={16} color="#b45309" />,
  error: <MdOutlineCancel size={16} color="#b91c1c" />,
  info: <LuInfo size={16} color="#1d4ed8" />,
  maintenance: <LuWrench size={16} color="#475569" />,
  update: <LuMegaphone size={16} color="#003a5d" />,
  urgent: <RiFileWarningFill size={16} color="#991b1b" />,
};

const iconBgMap: Record<MessageType, string> = {
  certification: "#dbeafe",
  warning: "#fef3c7",
  error: "#fee2e2",
  info: "#dbeafe",
  maintenance: "#f1f5f9",
  update: "#dbeafe",
  urgent: "#fecaca",
};

const DashboardMessages = () => {
  const { leaid } = useParams({ from: "/$leaid" });
  const messages = useDashboardMessages(leaid);

  return (
    <div
      className="card border-0 shadow-sm d-flex flex-column w-100"
      style={{
        borderRadius: "0.5rem",
        minHeight: 0,
      }}
    >
      <div
        className="d-flex align-items-center gap-2 px-3 py-2"
        style={{
          backgroundColor: "#334155",
          borderRadius: "0.5rem 0.5rem 0 0",
          color: "#fff",
          flexShrink: 0,
        }}
      >
        <LuMail size={16} color="#fff" />
        <h2
          style={{
            margin: 0,
            fontWeight: 600,
            fontSize: "0.85rem",
            letterSpacing: "0.05em",
            textTransform: "uppercase",
          }}
        >
          Important Messages
        </h2>
      </div>

      <div
        className="d-flex flex-column"
        style={{ overflowY: "auto", minHeight: 0, flex: 1 }}
      >
        {messages.length === 0 ? (
          <div
            className="px-3 py-4 text-muted"
            style={{ fontSize: "0.875rem" }}
          >
            No messages at this time.
          </div>
        ) : (
          messages.map((msg, i) => (
            <div
              key={msg.id}
              className="d-flex align-items-start gap-3 px-3"
              style={{
                borderBottom:
                  i < messages.length - 1 ? "1px solid #f1f5f9" : "none",
                paddingTop: 20,
                paddingBottom: 20,
              }}
            >
              <div
                style={{
                  width: 32,
                  height: 32,
                  borderRadius: "50%",
                  backgroundColor: iconBgMap[msg.type],
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexShrink: 0,
                }}
              >
                {iconMap[msg.type]}
              </div>
              <div>
                <h3
                  style={{
                    margin: 0,
                    fontWeight: 700,
                    fontSize: "0.875rem",
                    color: "#0f172a",
                  }}
                >
                  {msg.title}
                </h3>
                <div
                  style={{
                    fontSize: "0.875rem",
                    color: "#0f172a",
                    marginTop: 2,
                    lineHeight: 1.5,
                  }}
                >
                  {msg.body}
                </div>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default DashboardMessages;
